import React, { useEffect, useState } from "react";
import { getuserinfo } from "../userSlicerAction";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
import {
  Form,
  Container,
  Row,
  Col,
  Button,
  Spinner,
  Alert,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { loginPending, loginSucess, loginfailed } from "../userSlice";
import { userAuth } from "../utilities/userauth";
import { useNavigate } from "react-router-dom";

const LoginPage = ({ isLogin }) => {
  // const navigate = useNavigate()
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const { isLoading, isAuth, error } = useSelector((state) => state.login);

  useEffect(() => {
    console.log("eggectttttttttttttttt");
  });

  const [email, setEmail] = useState("");
  const [password, setPass] = useState("");

  const handleOnChange = (e) => {
    const { name, value } = e.target;

    switch (name) {
      case "email":
        setEmail(value);
        break;
      case "password":
        setPass(value);
        break;
      default:
        break;
    }
  };

  const Submithandler = async (e) => {
    // console.log(email, password);
    e.preventDefault();
    dispatch(loginPending());

    try {
      const user = await userAuth({ email, password });
      const { data } = user;
      if (data) {
        sessionStorage.setItem("accessJwt", data.data.refreshtoken);
        localStorage.setItem(
          "crmSite",
          JSON.stringify({ refreshtoken: data.data.refreshtoken })
        );
      }
      dispatch(loginSucess());
      console.log("ran started");
      dispatch(getuserinfo());
      console.log("ran started");
      navigate("/dashboard");

      // console.log(user);
    } catch (error) {
      console.log(error);
      dispatch(loginfailed(error));
    }

    if (!email || !password) {
      alert("pls fill email and password");
    }
    console.log(email, password);
  };
  if (sessionStorage.getItem("accessJwt")) {
    return navigate("/dashboard");
  }
  return (
    <Container>
      {console.log("nothinggggg")}

      <Row>
        <Col>
          <h3>Client Login Page</h3>
          {error && <Alert variant="danger">{error}</Alert>}
          <hr />
          <Form onSubmit={Submithandler}>
            <Form.Group>
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                value={email}
                name="email"
                placeholder="Email"
                onChange={handleOnChange}
              />
            </Form.Group>

            <Form.Group>
              <Form.Label>Password</Form.Label>
              <Form.Control
                type="password"
                name="password"
                value={password}
                placeholder="password"
                onChange={handleOnChange}
              />
              <Button type="submit" className="mt-2">
                Submit
              </Button>
              {isLoading && (
                <Spinner variant="primary" animation="border" mt="2" />
              )}
            </Form.Group>
          </Form>
        </Col>
      </Row>
      <Row>
        <a href="#!" onClick={() => isLogin("reset")}>
          Forget Password Reset it!
        </a>
      </Row>
    </Container>
  );
};

export default LoginPage;
